<template>
<div>
    <v-container fluid>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row justify="end" dense style="margin-top: -50px;">
            <v-btn class="ma-2 no-display mr-4" tile outlined color="warning" @click="print()">
            <v-icon left>mdi-printer</v-icon> Print 
        </v-btn>
        </v-row> 
        <div class="container-div">
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Employee Appraisal Report</v-toolbar-title>
                <v-divider class="mx-4 divider" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        <v-card class="box" v-if="measurement_list!=''">
            <!-- <v-col cols="12" sm="12" md="12" v-if="measurement_list!=''"> -->
            <v-simple-table fixed-header dense class="elevation-1" height="auto">
                <thead>
                    <tr>
                        <td class="">Sr. No.</td>
                        <td class="">Areas</td>
                        <td v-for="a in apprisal_level_list" :key="a.id">{{a.name}}</td>
                        <td v-for="a,index in authority_type_list" :key="index">{{a}} Score</td>
                    </tr>
                </thead>
                <tbody v-for="(s, index) in measurement_list" :key="index">
                    <td><strong>{{s.parameter_no}}</strong></td>
                    <td :colspan="apprisal_level_list.length+4"><strong>{{s.parameter_name}}</strong> </td>
                    <tr v-for="(s1, index1) in s.all_sub_parameter_list" :key="index1">
                        <td>{{s1.asp_no}}</td>
                        <td>{{s1.asp_name}}</td>
                        <td v-for="aspl,index1 in s1.asp_linking_level" :key="index1">
                            <span v-if="aspl.as_al_id">
                                {{aspl.as_al_description}}
                                <!-- <input v-if="aspl.as_al_id" class="mr-2 mt-2" type="checkbox" v-model="aspl.as_al_checked" @change="checkRadio(aspl.as_al_id,s1.asp_linking_level)" /><strong>Marks {{aspl.as_al_marks}}</strong> -->
                                <!-- <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon class="ml-5" v-bind="attrs" v-on="on" color="red">mdi-information</v-icon>
                                        </template>
                                        <span>
                                            {{aspl.as_al_description}}
                                        </span>
                                    </v-tooltip> -->
                            </span>
                        </td>
                        <td v-for="aspm,index2 in s1.asp_marks" :key="index2">
                            <strong>{{aspm.marks}}</strong>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
            <!-- </v-col> -->
        </v-card>
    </v-card>
        <v-card class="box" v-if="authority_score_List.length > 0">
            <v-container>
                <v-row v-for="(item, index) in authority_score_List" :key="index">
                    <v-col cols="12">
                        <h4><strong>{{ item.authority }}'s Remarks</strong></h4>
                        <div class="remarks-box">
                            {{ item.authority_remark ? item.authority_remark : 'No Remarks' }}
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-card class="box" v-if="appraisal_credit_list.length">
            <v-simple-table>
                <thead>
                    <tr>
                        <th rowspan="2">Sr. No.</th>
                        <th rowspan="2">Credit Area & Incharge for filling the service</th>
                        <th rowspan="2">Credit Points Allotted</th>
                        <th rowspan="2">Credit Point Obtained</th>
                        <th rowspan="2">Criteria</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in appraisal_credit_list" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.max_marks }}</td>
                        <td>{{ item.credit_point_obtained > 0 ? item.credit_point_obtained : "-" }}</td>
                        <td>{{ item.criteria }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card>

        <!-- Lesson Observation Score Section -->
        <v-card class="box" v-if="appraisal_parameter_evaluation_list.length">
            <v-simple-table>
                <thead>
                    <tr>
                        <th colspan="12" class="text-center">Lesson Observation Score:</th>
                    </tr>
                    <tr>
                        <th v-for="(i, index) in appraisal_parameter_evaluation_list" :key="index">
                            {{ i.name }}
                        </th>
                        <!-- <th>Credit Points</th> -->
                        <th>Total Score</th>
                        <th>Percentage</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td v-for="(i, index) in appraisal_parameter_evaluation_list" :key="index">
                            {{ i.obtained_marks > 0 ? i.obtained_marks : "-" }} / {{ i.max_marks }}
                        </td>
                        <!-- <td>{{ credit_points }}</td> -->
                        <td>{{ total_score > 0 ? total_score : "-" }} / {{ max_total_score }}</td>
                        <td>{{ percentage }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card>

        <!-- Signature Section -->
        <v-card class="box pa-4 mt-4">
            <div class="d-flex justify-space-between">
                <div>
                    <strong>HR's Sign:</strong> _______________
                </div>
                <div>
                    <strong>Approved by Principal:</strong> _______________
                </div>
            </div>
        </v-card>
    </div>
    </v-container>
</div> <!-- /. root div -->
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        title: "",
        description: "",
        headers: [{
                text: "Title",
                value: "title"
            },
            {
                text: "Description",
                value: "description"
            },
        ],
        measurement_list: [],
        apprisal_level_list: [],
        authority_type_list: [],
        headers: [{
                text: "Sr No",
                value: "srno"
            },
            {
                text: "Credit",
                value: "name"
            },
            {
                text: "Credit Points Alloted",
                value: "max_marks"
            },
            {
                text: "Credit Points Obtained",
                value: "credit_point_obtained"
            },
            {
                text: "Criteria",
                value: "criteria"
            },
        ],
        appraisal_credit_list: [],
        appraisal_parameter_evaluation_list: [],
        authority_score_List: [],
        total_score: 0,
        percentage: 0,
    }),
    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        onLoad() {
            const data={
                self_authority_id : localStorage.getItem("self_authority_id"),
                ay_id : localStorage.getItem("ay_id")
            }
            axios.post("/FillSelfAppriasal/getEmployeeAppraisalReport",data)
                .then(res => {
                    if (res.data.flag === "YES") {
                        this.measurement_list = res.data.measurement_list
                        this.apprisal_level_list = res.data.apprisal_level_list
                        this.authority_type_list = res.data.authority_type_list
                        this.appraisal_credit_list = res.data.instructor_appraisal_credit_list;
                        this.appraisal_parameter_evaluation_list = res.data.appraisal_parameter_evaluation_list;
                        this.total_score = res.data.cumulative_obtained_marks;
                        this.max_total_score = res.data.cumulative_max_marks;
                        this.percentage = res.data.percentage;
                        this.authority_score_List = res.data.authority_score_List
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })
                .catch(error => console.error(error));
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
    },
    watch: {},
};
</script>

<style scoped>
.container-div{
    background-color: white;
}
.remarks-box {
    min-height: 40px;
    border-bottom: 2px solid black;
    padding: 5px 0;
    font-size: 14px;
    white-space: pre-wrap;
    /* Ensures text wraps properly */
}

thead {
    font-weight: bold !important;
}

th {
    font-weight: bold !important;
}

tr,
td,
th {
    border: 1px solid black;
    /* text-align: center; */
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid black;
    border: 1px solid black;
    font-size: small;
}

td {
    font-size: small;
}

.weaklyoff {
    background: white !important;
}

.weaklyoff2 {
    background: yellow !important;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    /* text-align: center; */
    font-size: small;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
@media print{
    header,
    footer,
    nav,
    date {
        display: none !important;
    }
    body,
    tr,
    th,
    td {
        font-size: 16px !important;
    }
    body {
        background: white !important;
        color: black !important;
        font-size: 16px !important;
    }
    table, thead, tbody, tr, td, th {
        page-break-before: auto !important;
        page-break-after: auto !important;
        page-break-inside: avoid !important;
    }
    tr {
        page-break-inside: avoid !important;
    }

    .no-display,
    .divider,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }
    .v-card{
        border: none !important;
        box-shadow: none !important;
    }
    .container-div{
        margin-bottom: -10px !important;
    }
    .toolbar {
        display: block !important;
        visibility: visible !important;
        background: white !important; 
        font-size: 25px !important;
        color: black !important;
    }
    @page {
    margin: 0;
    padding-top: 0;
    size: 16.5in 16.5in !important;
    }
    @page:first{
        margin-top: -190px !important;
    }
}
</style>
